export default __webpack_public_path__ + "static/media/documents-icon-active.8e712548.svg";